import { inject, Injectable } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { filter } from 'rxjs/operators';

function promptUser(event: VersionReadyEvent): boolean { return true; }

@Injectable({ providedIn: 'root' })
export class PromptUpdateService {

    swUpdate = inject(SwUpdate);

    constructor() {
        this.swUpdate.versionUpdates
            .pipe(filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'))
            .subscribe(evt => { if (promptUser(evt)) { document.location.reload(); } }
        );
    }
}
